/**
 * Shared presentation-state grammar for operational UI primitives.
 * Aligned with PRIMITIVE_PRESENTATION_STATES_V0 in primitiveContracts.ts.
 */

export const PRIMITIVE_PRESENTATION_STATES = [
  'loading',
  'empty',
  'partial',
  'ready',
  'failed',
  'denied',
] as const;

export type PrimitivePresentationState = (typeof PRIMITIVE_PRESENTATION_STATES)[number];

export const PRIMITIVE_AUTHORITY_FLAGS = {
  grantsAuthority: false,
  grantsApproval: false,
} as const;

export type PrimitiveAuthorityFlags = typeof PRIMITIVE_AUTHORITY_FLAGS;

export function isPrimitivePresentationState(value: string): value is PrimitivePresentationState {
  return (PRIMITIVE_PRESENTATION_STATES as readonly string[]).includes(value);
}

/** Map presentation state to landmark role for a11y. */
export function resolvePrimitiveStatusRole(
  state: PrimitivePresentationState
): 'status' | 'alert' | undefined {
  if (state === 'failed' || state === 'denied') return 'alert';
  if (state === 'partial' || state === 'loading' || state === 'ready') return 'status';
  return undefined;
}

export function resolvePrimitiveAriaBusy(state: PrimitivePresentationState): boolean {
  return state === 'loading';
}
